import { MessageCircle } from "lucide-react";
import { generateWhatsAppLink, generateGeneralInquiryMessage, generateProductOrderMessage } from "../utils/whatsapp";
import { useTranslation } from "react-i18next";

const WhatsAppButton = ({ variant = "full", productName, productPrice }) => {
  const { t } = useTranslation();
  const getMessage = () => {
    if (productName && productPrice) {
      return generateProductOrderMessage(productName, productPrice);
    }
    return generateGeneralInquiryMessage();
  };

  const link = generateWhatsAppLink(getMessage());

  if (variant === "nav") {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-whatsapp text-sm px-5 py-2.5"
      >
        <MessageCircle size={18} />
        <span>{t("common.Order Now")}</span>
      </a>
    );
  }

  if (variant === "hero") {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-whatsapp text-lg px-8 py-4"
      >
        <MessageCircle size={22} />
        <span>{t("common.Order on WhatsApp")}</span>
      </a>
    );
  }

  if (variant === "product") {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-whatsapp w-full text-sm py-3"
      >
        <MessageCircle size={18} />
        <span>{t("common.Order via WhatsApp")}</span>
      </a>
    );
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-whatsapp w-full"
    >
      <MessageCircle size={20} />
      <span>{t("common.Order on WhatsApp")}</span>
    </a>
  );
};

export default WhatsAppButton;
